export enum EbpCaseSupportAuthorizationActionType {
  not_required = 'not_required',
  requested = 'requested',
  approved = 'approved',
  rejected = 'rejected',
  task_board = 'task_board',
}
